import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbActions } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import { CommonData } from '../../providers/common-data';

/**
 * Generated class for the PbcatrulesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'pbcatrules',
  templateUrl: 'pbcatrules.html'
})
export class PbcatrulesComponent {
  private _pbkategorie_id;
  @Input('pbkategorie_id') 
  get pbkategorie_id(): number {
    return this._pbkategorie_id;
  }
  set pbkategorie_id(value: number) {
    this._pbkategorie_id = value;
    this.refreshCategoryDetails();
  }    

  private _readonly = true;
  @Input('readonly') 
  get readonly(): boolean {
    return this._readonly;
  }
  set readonly(value: boolean) {
    this._readonly = "" + value !== "false";
  }    

  private _periodcount = 0;
  @Input('periodcount')
  get periodcount(): number {
    return this._periodcount;
  }
  set periodcount(value: number) {
    this._periodcount = value;
  }     

  

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  private pbregelnbycatid;
  private selectedkategorie;

  constructor(
    public userData: UserData
    ,public pbData: ParkbewilligungenData
    , public common: CommonData
  ) 
  {
      this.pbregelnbycatid = [];
  }

  refreshCategoryDetails(){    
    this.selectedkategorie = this.pbData.pbcategories.find(x => x.id === this._pbkategorie_id);
    //pd.period.edited = "changed";
    if(this.pbregelnbycatid){
      this.pbregelnbycatid.length = 0;
    }
    this.pbData.pbregelnbycatid(this._pbkategorie_id).then(res => {
      
      if(res){
        this.pbregelnbycatid = res;
      }

      //this.oSelectedKategorieRegeln = res;
    });    
    //console.log(this.oSelectedKategorie);
  }


  rulesChanged(event, pbregeln_cat,regelindex){
    if(!this.pbregelnbycatid[regelindex].edited){
      this.pbregelnbycatid[regelindex].edited="changed";
    }

    if(this.onChange){
      this.onChange.emit();
    }
  }  

  addRule(){
    if(!this.pbregelnbycatid){
      this.pbregelnbycatid = [];
    }
    this.pbregelnbycatid.push({edited:"added", name:"Regelname", zeit_von:"00:00:00", zeit_bis:"23:59:59", mo:1, di:1, mi:1, do:1, fr:1, sa:1, so:1})
    this.rulesChanged(null, this.pbregelnbycatid[this.pbregelnbycatid.lenght-1], this.pbregelnbycatid.length-1);
  }

  discardChanges(){
    this.refreshCategoryDetails();
  }
  updateChanges(){
    //console.log(this.pbregelnbycatid);
    this.pbData.updatepbkategorieregeln(this._pbkategorie_id, this.pbregelnbycatid).then(res => {
      //console.log(res);
      this.pbregelnbycatid = res;
      //this.oSelectedKategorieRegeln = res;
    });        
  }
  removeRule(pbregeln_cat, regelindex){
    console.log(this.pbregelnbycatid);
    if(pbregeln_cat.edited && pbregeln_cat.edited == "removed"){
     delete pbregeln_cat.edited;
    }
    else if(pbregeln_cat.edited && pbregeln_cat.edited == "added"){
     //delete pbregel;
     this.pbregelnbycatid.splice(regelindex,1);
    }
    else{
      console.log('remove rule');
      //console.log(this.pbregelnbycatid[regelindex]);
      this.pbregelnbycatid[regelindex].edited="removed";
      this.rulesChanged(null, pbregeln_cat, regelindex);
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/components/pbcatrules/pbcatrules.ts